import { useTranslation } from "@outschool/localization";
import { useCallback } from "react";

export function useFormatDuration() {
  const { t } = useTranslation("ui-components-classroom\\useFormatDuration");

  return useCallback(
    (minutes: number, hasVideo?: boolean): string => {
      if (minutes < 60) {
        return hasVideo
          ? t("{{minutes}} min video", { minutes })
          : t("{{minutes}} min read", { minutes });
      }
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      const time =
        remainingMinutes > 0
          ? t("{{hours}}h {{minutes}}m", { hours, minutes: remainingMinutes })
          : t("{{hours}}h", { hours });
      return hasVideo
        ? t("{{time}} video", { time })
        : t("{{time}} read", { time });
    },
    [t],
  );
}
